import { Check, X } from "lucide-react";

import { CaseDomainsTableActions } from "./CaseDomainsTableActions";

const BooleanCell = ({ value, label }) =>
  value ? (
    <Check className="tw:size-4 tw:text-[#24B388]" aria-label={label} />
  ) : (
    <X className="tw:text-destructive tw:size-4" aria-label={`Not ${label}`} />
  );

export const getCaseDomainsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Computer Domain",
      id: "Computer Domain",
      accessorKey: "computer_domain",
      cell: ({ row }) => (
        <BooleanCell
          value={row.original?.computer_domain}
          label="Computer Domain"
        />
      ),
    },
    {
      header: "Email Domain",
      id: "Email Domain",
      accessorKey: "email_domain",
      cell: ({ row }) => (
        <BooleanCell value={row.original?.email_domain} label="Email Domain" />
      ),
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <CaseDomainsTableActions original={row.original} />,
    },
  ];
};
